export default {
  transaction_id: "Transaktions ID",
  service_date: "Datum der Dienstleistung",
  change_plan_button_title: "Plan ändern",
  trial_period: "Probezeit",
  minimum_value_for_payment_error: "Der Mindestwert ist 2.",
  choose_tenant_dialog_title:
    "Wähle das Unternehmen, bei dem du dich anmelden möchtest",
  select: "Auswählen",
  choose_tenant_dialog_forgotten_password_title:
    "Wähle das Unternehmen, bei dem du das Passwort ändern möchtest",
  user_uses_email_already:
    "Die ausgewählte E-Mail-Adresse wird vom Kunden oder einem anderen Mitarbeiter verwendet.",
  fields_required: "* - Pflichtfelder",
  add_resources_with_plus:
    'Keine Ressourcen. Füge Ressourcen hinzu, indem du auf der rechten Seite auf "+" klickst.',
  add_categories_with_plus:
    'Keine Kategorie verfügbar. Füge eine Kategorie hinzu, indem du auf der rechten Seite auf "+" klickst.',
  email_sent: "E-mail wurde gesendet",
  sms_sent: "SMS-Nachricht wurde gesendet",
  payment_method_missing:
    'Du hast keine Zahlungsmethode verbunden. Gehe zum Tab "Abrechnungen" und füge eine Zahlungsmethode hinzu.',
  invoice_data_missing:
    'Du hast keine abgeschlossenen Daten für die Umsatzsteuerrechnung. Gehe zur Registerkarte "Abrechnungen" und fülle die Daten aus.',
  my_web_template: "Meine Webseite",
  no_websites_info:
    "Du hast noch keine Websites hinzugefügt, klicke unten, um die erste hinzuzufügen.",
  no_website_info_button: "Neue Website",
  no_mobile_apps_info:
    "Du hast noch kein mobiles App-Projekt, klicke unten, um das erste hinzuzufügen.",
  no_mobile_apps_info_button: "Erstelle eine mobile App",
  my_mobile_app_template: "Meine mobile-App",
  company_name_2: "Unternehmensname oder Vor- und Nachname",
  go_back: "Zurück",
  new_feature: "Neue Funktion in Calendesk",
  notifications_banner_text:
    "Personalisiere E-Mail, SMS und Push-Benachrichtigungen ganz einfach.",
  edit_now: "Jetzt bearbeiten",
  notification_templates_list: "Vorlagen",
  notification_templates_list_header: "Panel / Benachrichtigungen",
  booking_prepayment: "Neue Buchung - Zahlung erforderlich",
  booking_prepayment_info:
    'Diese Benachrichtigung wird gesendet, wenn eine Buchung erstellt wird, die eine Zahlung vor der Bestätigung erfordert. Die Benachrichtigung wird nicht gesendet, wenn die Einstellung „Neue Buchung - Zahlung erforderlich" deaktiviert ist oder wenn beim Erstellen der Buchung die Option „Die Erstellung eines Besuchs nicht melden" ausgewählt wurde.',
  booking_created: "Buchungsbestätigung",
  booking_created_info:
    'Diese Benachrichtigung wird nach dem Erstellen einer Buchung mit dem Status "Akzeptiert" und nach erfolgter Zahlung gesendet. Eine Benachrichtigung wird nicht gesendet, wenn die Einstellung „Buchungsbestätigung“ deaktiviert ist oder wenn beim Erstellen der Buchung die Option „Die Erstellung eines Besuchs nicht melden“ ausgewählt wurde.',
  booking_updated: "Buchungsänderung",
  booking_updated_info:
    "Diese Benachrichtigung wird gesendet, nachdem eine Buchung geändert wurde (d. h. eine Änderung des Status, des Datums oder der Uhrzeit des Meetings, des Mitarbeiters, des Kunden, des Standorts oder der Dienstleistung vorgenommen wurde). Eine Benachrichtigung wird nicht gesendet, wenn die Einstellung „Buchungsänderung“ deaktiviert ist oder wenn bei der Änderung der Buchung die Option „Änderung/Löschung des Besuchs nicht melden“ ausgewählt wurde.",
  booking_deleted: "Löschung einer Buchung",
  booking_deleted_info:
    "Diese Benachrichtigung wird nach dem Löschen oder Stornieren einer Buchung gesendet. Eine Benachrichtigung wird nicht versendet, wenn der Einstellungstyp „Löschung einer Buchung“ ausgeschaltet ist oder wenn beim Löschen der Buchung die Option „Die Löschung nicht melden“ ausgewählt wurde.",
  booking_reminder: "Buchungserinnerung",
  booking_reminder_info:
    'Die Benachrichtigung wird gemäß der eingestellten Zeit vor der Reservierung an Reservierungen mit dem Status "Akzeptiert" gesendet. Die Benachrichtigung wird nicht gesendet, wenn die Benachrichtigungsart "Reservierungserinnerung" ausgeschaltet ist.',
  account_activate: "Kontoaktivierung - Willkommens-E-Mail",
  account_activate_info:
    "Diese Benachrichtigung wird gesendet, nachdem ein Kunde sein eigenes Konto auf der von Calendesk generierten Seite erstellt hat.",
  "account_password-reset": "Passwort zurücksetzen",
  "account_password-reset_info":
    "Diese Benachrichtigung wird gesendet, nachdem die Passworterinnerungsoption auf der von Calendesk generierten Seite verwendet wurde.",
  newsletter_subscribe: "Newsletter-Abo",
  newsletter_subscribe_info:
    "Diese Benachrichtigung wird gesendet, nachdem die Newsletter-Anmeldeoption auf der von Calendesk generierten Seite verwendet wurde.",
  "simple-store-product-transaction_paid": "Shop - Kaufbestätigung",
  edited: "Bearbeitet",
  "simple-store-product-transaction_paid_info":
    "Die Benachrichtigung wird an die Haupt-E-Mail-Adresse des Kontos gesendet, nachdem Produkte auf der in Calendesk generierten Seite gekauft wurden. Die Benachrichtigung wird nicht gesendet, wenn Produkte während der Reservierung des Besuchs gekauft werden (Benachrichtigungen über Reservierungen enthalten bereits diese Informationen).",
  notification_info:
    "Das Bearbeiten von Benachrichtigungen hilft dir dabei, den Inhalt von Benachrichtigungen an deine Anforderungen anzupassen. Du kannst die erweiterte Bearbeitung von Benachrichtigungen mithilfe der sogenannten Variablen verwenden oder die Standardeinstellungen belassen. Standardbenachrichtigungen enthalten alle notwendigen Informationen, die deine Kunden und Mitarbeiter erhalten sollten.",
  notification_templates_list_for_client: "Kundenbenachrichtigungen",
  notification_templates_list_for_tenant:
    "Benachrichtigungen an deinen Mitarbeiter",
  notification_templates_list_for_tenant_info:
    "Benachrichtigungen an Mitarbeiter werden an die E-Mail-Adressen der Mitarbeiter gesendet oder, falls diese fehlen, an die primäre Adresse des Kontos (Registerkarte Einstellungen / Dein Unternehmen).",
  notification_templates_list_information:
    "Im Menü auf der linken Seite kannst du deine Benachrichtigungen anpassen. Du hast die Möglichkeit, Variablen im Nachrichteninhalt zu verwenden. Variablen haben das Format „[NAME]” und werden automatisch durch die entsprechenden Werte ersetzt, z. B. den Namen des Dienstes oder den Namen des Kunden. Diese Werte werden aus den Dienst- und Benutzereinstellungen übernommen. Um eine Variable auszuwählen, klicke auf die blaue Schaltfläche mit dem Symbol „+” (Plus) neben dem Nachrichtentitel oder auf die blaue Schaltfläche „Hier klicken” unter dem Feld, in dem du die Benachrichtigung festlegst, und wähle die Variable aus, die im Inhalt erscheinen soll.",
  ready: "Fertig",
  notification_templates_list_preview_title: "Vorschau von Beispielnachrichten",
  notification_template_editor_sidebar_email_title: "E-Mail",
  notification_template_editor_sidebar_sms_title: "SMS",
  notification_template_editor_sidebar_push_title: "Push-Benachrichtigung",
  notification_template_editor_sidebar_text: "Text",
  notification_template_editor_publish_title:
    "Inhalt der Benachrichtigungen ändern",
  notification_template_editor_publish_cancel_title: "Änderungen löschen",
  notification_template_editor_publish_text:
    "Die Änderung wird sofort umgesetzt.",
  notification_template_editor_publish_cancel_text:
    "Die vorgenommenen Änderungen werden gelöscht.",
  notification_template_editor_publish_warning:
    "Dieser Vorgang kann nicht rückgängig gemacht werden!",
  notification_template_editor_publish_confirmation_button:
    "Benachrichtigungen ändern",
  notification_template_editor_publish_cancel_confirmation_button:
    "Änderungen löschen",
  notification_template_editor_sidebar_restore_all:
    "Standardinhalte wiederherstellen",
  notification_template_editor_sidebar_restore_all_information:
    "Die Standardbenachrichtigungen aus dieser Gruppe werden wiederhergestellt.",
  notification_template_editor_sidebar_restore_all_button: "Wiederherstellen",
  booking_prepayment_email_subject_client:
    "Zahlung erforderlich: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_prepayment_email_text_client:
    '<h1>Buchungsnummer: [BOOKING_ID]</h1><hr/><p>Hallo,</p><p>Deine Buchung für <b>[SERVICE_NAME]</b> erfordert eine Zahlung.</p><p><b>Datum und Uhrzeit:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p><p><b>Betrag:</b><br>[BOOKING_PRICE]</p>[BOOKING_CUSTOM_FIELDS]<p><b>Deine Buchung wird storniert, wenn die Zahlung nicht innerhalb von [BOOKING_AWAITING_PAYMENT_FULL_TIME] erfolgt. Klicke unten, um zu deiner Buchung zu gelangen und die Zahlung vorzunehmen.</b></p><p class="cd-paragraph"></p>[MANAGE_CUSTOMER_BOOKING_BUTTON]',
  booking_created_email_subject_client:
    "Bestätigt: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_created_email_text_client:
    '<h1>Buchungsnummer: [BOOKING_ID]</h1><hr/><p>Hallo,</p><p>Deine Buchung für <b>[SERVICE_NAME]</b> wurde bestätigt.</p><p><b>Datum und Uhrzeit:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p><p><b>Ort:</b><br>[BOOKING_LOCATION] [BOOKING_ONLINE_MEETING_URL]</p>[BOOKING_CUSTOM_FIELDS] [ADDITIONAL_INFORMATION_AFTER_BOOKING]<p class="cd-paragraph"></p>[MANAGE_CUSTOMER_BOOKING_BUTTON][ADD_TO_CALENDAR_BUTTONS]',
  booking_created_email_subject_tenant:
    "Neue Buchung: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_created_email_text_tenant:
    '<h1>Buchungsnummer: [BOOKING_ID]</h1><hr/><p>Hallo,</p><p><b>Eine neue Buchung wurde vorgenommen für den Service:</b><br> [SERVICE_NAME]</p><p><b>Kunde:</b><br>[CUSTOMER_FULL_NAME]</p><p><b>Mitarbeiter:</b><br>[EMPLOYEE_FULL_NAME]</p><p><b>Datum und Uhrzeit:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p><p><b>Ort:</b><br>[BOOKING_LOCATION] [BOOKING_ONLINE_MEETING_URL]</p>[BOOKING_CUSTOM_FIELDS] [ADDITIONAL_INFORMATION_AFTER_BOOKING]<p class="cd-paragraph"></p>[MANAGE_EMPLOYEE_BOOKING_BUTTON]',
  booking_updated_email_subject_client:
    "Umbuchung: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_updated_email_text_client:
    '<h1>Buchungsnummer: [BOOKING_ID]</h1><hr/><p>Hallo,</p><p>Deine Buchung für <b>[SERVICE_NAME]</b> wurde geändert.</p><p><b>Datum und Uhrzeit:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p><p><b>Ort:</b><br>[BOOKING_LOCATION] [BOOKING_ONLINE_MEETING_URL]</p>[BOOKING_CUSTOM_FIELDS] [ADDITIONAL_INFORMATION_AFTER_BOOKING]<p class="cd-paragraph"></p>[MANAGE_CUSTOMER_BOOKING_BUTTON][ADD_TO_CALENDAR_BUTTONS]',
  booking_updated_email_subject_tenant:
    "Umbuchung: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_updated_email_text_tenant:
    '<h1>Buchungsnummer: [BOOKING_ID]</h1><hr/><p>Hallo,</p><p><b>Die Buchung für den Service wurde geändert:</b><br> [SERVICE_NAME]</p><p><b>Kunde:</b><br>[CUSTOMER_FULL_NAME]</p><p><b>Mitarbeiter:</b><br>[EMPLOYEE_FULL_NAME]</p><p><b>Datum und Uhrzeit:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p><p><b>Ort:</b><br>[BOOKING_LOCATION] [BOOKING_ONLINE_MEETING_URL]</p>[BOOKING_CUSTOM_FIELDS] [ADDITIONAL_INFORMATION_AFTER_BOOKING]<p class="cd-paragraph"></p>[MANAGE_EMPLOYEE_BOOKING_BUTTON]',
  booking_deleted_email_subject_client:
    "Buchung storniert: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_deleted_email_text_client:
    "<h1>Buchungsnummer: [BOOKING_ID]</h1><hr/><p>Hallo,</p><p>Wir möchten Sie darüber informieren, dass Ihre Buchung für <b>[SERVICE_NAME]</b> storniert wurde.</p><p><b>Datum und Uhrzeit:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p>",
  booking_deleted_email_subject_tenant:
    "Buchung storniert: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_deleted_email_text_tenant:
    '<h1>Buchungsnummer: [BOOKING_ID]</h1><hr/><p>Hallo,</p><p>Wir möchten Sie darüber informieren, dass die Buchung für <b>[SERVICE_NAME]</b> storniert wurde.</p><p><b>Kunde:</b><br>[CUSTOMER_FULL_NAME]</p><p><b>Mitarbeiter:</b><br>[EMPLOYEE_FULL_NAME]</p><p><b>Datum und Uhrzeit:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p><p class="cd-paragraph"></p>[MANAGE_EMPLOYEE_BOOKING_BUTTON]',
  booking_reminder_email_subject_client:
    "Buchungserinnerung: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_reminder_email_text_client:
    '<h1>Buchungsnummer: [BOOKING_ID]</h1><hr/><p>Hallo,</p><p>Dies ist eine Erinnerung an deine Buchung für <b>[SERVICE_NAME]</b></p><p><b>Datum und Uhrzeit:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p><p><b>Ort:</b><br>[BOOKING_LOCATION] [BOOKING_ONLINE_MEETING_URL]</p>[BOOKING_CUSTOM_FIELDS] [ADDITIONAL_INFORMATION_AFTER_BOOKING]<p class="cd-paragraph"></p>[MANAGE_CUSTOMER_BOOKING_BUTTON]',
  booking_reminder_email_subject_tenant:
    "Buchungserinnerung: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_reminder_email_text_tenant:
    '<h1>Buchungsnummer: [BOOKING_ID]</h1><hr/><p>Hallo,</p><p>Dies ist eine Erinnerung an die Buchung für den Service:</p><p> [SERVICE_NAME]</p><p><b>Kunde:</b><br>[CUSTOMER_FULL_NAME]</p><p><b>Mitarbeiter:</b><br>[EMPLOYEE_FULL_NAME]</p><p><b>Datum und Uhrzeit:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p><p><b>Ort:</b><br>[BOOKING_LOCATION] [BOOKING_ONLINE_MEETING_URL]</p>[BOOKING_CUSTOM_FIELDS] [ADDITIONAL_INFORMATION_AFTER_BOOKING]<p class="cd-paragraph"></p>[MANAGE_EMPLOYEE_BOOKING_BUTTON]',
  booking_created_push_subject_client: "Vielen Dank für Ihre Buchung",
  booking_created_push_text_client:
    "[SERVICE_NAME] bei [COMPANY_NAME] am [BOOKING_START_DATE] um [BOOKING_START_TIME].",
  booking_created_push_subject_tenant: "[COMPANY_NAME] - Neue Buchung",
  booking_created_push_text_tenant:
    "Dienstleistung: [SERVICE_NAME], Kunde: [CUSTOMER_FULL_NAME], Datum: [BOOKING_START_DATE], Uhrzeit: [BOOKING_START_TIME].",
  booking_updated_push_subject_client: "Ihre Buchung wurde geändert",
  booking_updated_push_text_client:
    "[SERVICE_NAME] bei [COMPANY_NAME] am [BOOKING_START_DATE] um [BOOKING_START_TIME], Status: [BOOKING_STATUS].",
  booking_updated_push_subject_tenant: "[COMPANY_NAME] - Buchungsänderung",
  booking_updated_push_text_tenant:
    "Dienstleistung: [SERVICE_NAME], Kunde: [CUSTOMER_FULL_NAME], Datum: [BOOKING_START_DATE], Uhrzeit: [BOOKING_START_TIME], Status: [BOOKING_STATUS].",
  booking_deleted_push_subject_client: "Die Buchung wurde gelöscht",
  booking_deleted_push_text_client:
    "[SERVICE_NAME] bei [COMPANY_NAME] am [BOOKING_START_DATE] um [BOOKING_START_TIME].",
  booking_deleted_push_subject_tenant:
    "[COMPANY_NAME] - Die Buchung wurde gelöscht",
  booking_deleted_push_text_tenant:
    "Dienstleistung: [SERVICE_NAME], Kunde: [CUSTOMER_FULL_NAME], Datum: [BOOKING_START_DATE], Uhrzeit: [BOOKING_START_TIME].",
  booking_reminder_push_subject_client: "Buchungserinnerung",
  booking_reminder_push_text_client:
    "[SERVICE_NAME] bei [COMPANY_NAME] am [BOOKING_START_DATE] um [BOOKING_START_TIME].",
  booking_reminder_push_subject_tenant: "[COMPANY_NAME] - Buchungserinnerung",
  booking_reminder_push_text_tenant:
    "Dienstleistung: [SERVICE_NAME], Kunde: [CUSTOMER_FULL_NAME], Datum: [BOOKING_START_DATE], Uhrzeit: [BOOKING_START_TIME].",
  booking_prepayment_sms_text_client:
    "Zahlung erforderlich: [SERVICE_NAME] bei [COMPANY_NAME] am [BOOKING_START_DATE] um [BOOKING_START_TIME]. Hier bezahlen: [BOOKING_CONTROL_URL]",
  booking_created_sms_text_client:
    "Vielen Dank für Ihre Buchung für [SERVICE_NAME] bei [COMPANY_NAME] am [BOOKING_START_DATE] um [BOOKING_START_TIME].",
  booking_created_sms_text_tenant:
    "[COMPANY_NAME] - Neue Buchung: [SERVICE_NAME]. Kunde: [CUSTOMER_FULL_NAME], Datum: [BOOKING_START_DATE], Uhrzeit: [BOOKING_START_TIME].",
  booking_updated_sms_text_client:
    "Die Buchung bei [SERVICE_NAME] in [COMPANY_NAME] wurde geändert. Am [BOOKING_START_DATE] um [BOOKING_START_TIME], Status: [BOOKING_STATUS].",
  booking_updated_sms_text_tenant:
    "[COMPANY_NAME] - Buchungsänderung: [SERVICE_NAME]. Kunde: [CUSTOMER_FULL_NAME], Datum: [BOOKING_START_DATE], um.: [BOOKING_START_TIME], Status: [BOOKING_STATUS].",
  booking_deleted_sms_text_client:
    "Die Buchung für [SERVICE_NAME] bei [COMPANY_NAME] wurde gelöscht. Am [BOOKING_START_DATE] um [BOOKING_START_TIME].",
  booking_deleted_sms_text_tenant:
    "[COMPANY_NAME] - Buchungen entfernt: [SERVICE_NAME]. Kunde: [CUSTOMER_FULL_NAME], Datum: [BOOKING_START_DATE], Uhrzeit: [BOOKING_START_TIME].",
  booking_reminder_sms_text_client:
    "Erinnerung an den Besuch bei [COMPANY_NAME] am [BOOKING_START_DATE] um [BOOKING_START_TIME]. Tel.: [COMPANY_PHONE].",
  booking_reminder_sms_text_tenant:
    "[COMPANY_NAME] - Erinnerung an die Buchung bei [SERVICE_NAME]. Kunde: [CUSTOMER_FULL_NAME], Datum: [BOOKING_START_DATE], Uhrzeit: [BOOKING_START_TIME].",
  account_activate_email_subject_client:
    "Bestätigung der Registrierung bei [COMPANY_NAME]",
  account_activate_email_text_client:
    "<h1>Willkommen bei [COMPANY_NAME]</h1><p>Wir freuen uns, dass du dich uns anschließen möchtest. Du bist nur einen Schritt davon entfernt, die Werkzeuge zu nutzen, die den Zugang zu unseren Dienstleistungen erleichtern. Schließe die Registrierung ab, indem du dein Konto aktivierst.</p>",
  account_activate_email_cta_button_client: "Konto aktivieren",
  "account_password-reset_email_subject_client":
    "Dein Passwort für [COMPANY_NAME]",
  "account_password-reset_email_text_client":
    "<h1>Dein Passwort für [COMPANY_NAME]</h1><p>Klicke unten, um dein Passwort für dein Konto bei [COMPANY_NAME] festzulegen.</p>",
  "account_password-reset_email_cta_button_client": "Passwort erstellen",
  newsletter_subscribe_email_subject_client:
    "Bestätigung des Newsletter-Abos von [COMPANY_NAME]",
  newsletter_subscribe_email_text_client:
    '<h1>Bestätigung der Newsletter-Anmeldung bei [COMPANY_NAME]</h1><p class="cd-paragraph">Klicke unten, um deine Anmeldung für den Newsletter von [COMPANY_NAME] zu bestätigen. Wenn du diese Nachricht irrtümlich erhalten hast, kannst du sie einfach ignorieren.</p>',
  newsletter_subscribe_email_cta_button_client: "Bestätigen",
  "simple-store-product-transaction_paid_email_subject_client":
    "Vielen Dank für Ihren Einkauf [PRODUCT_NAME]",
  "simple-store-product-transaction_paid_email_text_client":
    '<h1>Dies ist eine Zahlungsbestätigung</h1><p class="cd-paragraph">Vielen Dank für den Kauf von [PRODUCT_NAME].</p><p>Preis: [PRODUCT_PRICE], Menge: [PRODUCT_QUANTITY].</p><p>Zusätzliche Informationen: [PRODUCT_DESCRIPTION]</p>',
  "simple-store-product-transaction_paid_email_subject_tenant":
    "Neuer Kauf [PRODUCT_NAME]",
  "simple-store-product-transaction_paid_email_text_tenant":
    '<h1>Neuer Kauf von [PRODUCT_NAME]</h1><p class="cd-paragraph">Dein Produkt [PRODUCT_NAME] wurde vom Kunden [CUSTOMER_FULL_NAME] gekauft.</p><p>Preis: [PRODUCT_PRICE], Menge: [PRODUCT_QUANTITY].</p><p>Zusätzliche Informationen: [PRODUCT_DESCRIPTION]</p>',
  employee_example_name: "John",
  employee_example_surname: "Fleißig",
  employee_example_fullname: "John Fleißig",
  customer_example_name: "Anna",
  customer_example_surname: "Schmitt",
  customer_example_fullname: "Anna Schmitt",
  service_example_name: "ABC-Dienstleistung",
  service_example_name_2: "Online-Beratung",
  phone_number_is_missing: "Telefonnummer fehlt",
  company_address_is_missing: "Unternehmensadresse fehlt",
  sms_title: "Nachricht",
  email_subject: "Betreff",
  push_now_indicator: "jetzt",
  variable_customer_full_name: "Vor- und Nachname des Kunden",
  variable_customer_id: "Kundennummer",
  variable_customer_name: "Vorname des Kunden",
  variable_customer_surname: "Name des Kunden",
  variable_customer_email: "E-Mail des Kunden",
  variable_customer_phone: "Telefon des Kunden",
  variable_employee_id: "Mitarbeiter-ID-Nummer",
  variable_employee_name: "Vorname des Mitarbeiters",
  variable_employee_email: "E-Mail des Mitarbeiters",
  variable_employee_phone: "Telefon des Mitarbeiters",
  variable_employee_surname: "Name des Mitarbeiters",
  variable_employee_full_name: "Vor- und Nachname des Mitarbeiters",
  variable_booking_id: "Buchungs-ID-Nummer",
  variable_booking_start_date: "Buchungsdatum",
  variable_booking_start_time: "Zeitpunkt der Buchung",
  variable_booking_end_date: "Enddatum der Buchung",
  variable_booking_end_time: "Endzeitpunkt der Buchung",
  variable_service_id: "ID-Dienstleistungsnr",
  variable_service_name: "Name der Dienstleistung",
  variable_booking_price: "Dienstleistungspreise",
  variable_company_name: "Unternehmensname",
  variable_company_phone: "Telefonnummer des Unternehmens",
  variable_company_address: "Adresse des Unternehmens",
  variable_booking_status: "Buchungsstatus",
  variable_booking_payment_status: "Zahlungsstatus der Buchung",
  variable_newsletter_email: "E-Mail-Adresse",
  variable_unsubscribe_url: "Schreib mich ab url",
  variable_product_id: "Produkt-ID-Nummer",
  variable_product_name: "Produktname",
  variable_product_description: "Zusätzliche Produktinformationen",
  variable_product_price: "Produktpreis",
  variable_product_quantity: "Stückzahl des Produktes",
  variable_product_list: "Liste der gekauften Produkte",
  variable_booking_location: "Standort",
  variable_booking_time_zone: "Zeitzone",
  variable_booking_recurrence_description:
    "Beschreibung der zyklischen Reservierung",
  variable_online_meeting_url: "Link zum Online-Meeting",
  variable_booking_control_url: "Buchungs-URL",
  variable_booking_created_by_user_id: "Ersteller-ID-Nummer",
  variable_booking_updated_by_user_id: "ID-Nummer des letzten Bearbeiters",
  variable_booking_created_by: "Name des Erstellers",
  variable_booking_updated_by: "Name des letzten Bearbeiters",
  variable_booking_custom_fields: "Felder des Buchungsformulars",
  add_variable_info_text: "Klicke hier, um die Variable hinzuzufügen",
  rename: "Unbenennen",
  hide: "Verstecken",
  change_url: "Verknüpfung ändern",
  back: "Zurück",
  your_pictures: "Deine Galerie",
  photo_library_unsplash: "Fotobibliothek (kostenlos)",
  search_for_photos: "Suche in Millionen von Bildern",
  search_for_photos_hint: "Bei Unsplash kannst du nur auf Englisch suchen.",
  photos_by_unsplash: "Bilder von Unsplash",
  photo_by_on_unsplash: "Bildautor @{name} von Unsplash",
  unsplash_photo_added_to_gallery:
    "Das Bild ist jetzt in deiner Galerie verfügbar.",
  for_example_unsplash: "z.B. Blumen",
  new_website_builder_title: "Neuer Webeditor",
  website_builder_banner_text:
    "Jetzt ist es da! Erstelle deine Website mit dem neuen Editor!",
  check_now: "Jetzt prüfen",
  // Color picker
  cp_alert_p1: "Zu geringer Kontrast gewählt!",
  cp_alert_p2: "Das Element wird schlecht lesbar sein.",
  // Website builder
  wb_website_builder: "Website-Editor",
  wb_move_up: "Nach oben verschieben",
  wb_move_down: "Nach unten verschieben",
  wb_auto_save_info: "Änderungen werden automatisch gespeichert",
  wb_pages: "Unterseiten",
  wb_add_new_section: "Abschnitt hinzufügen",
  wb_select_new_section: "Abschnitt auswählen",
  wb_add_new_section_info:
    "Wähle einen Abschnitt aus dem Menü auf der linken Seite",
  wb_add_new_page: "Unterseite hinzufügen",
  wb_add_page_dialog_type_page_name_label: "Name z. B. Dienstleistungen",
  wb_add_page_dialog_type_page_name_blog_label: "Name z.B. Blog",
  wb_add_page_dialog_type_page_description:
    "Beschreibung (sichtbar für Suchmaschinen wie Google)",
  wb_add_page_dialog_type_page_description_hint:
    "Gib eine einzigartige, kurze Beschreibung des Inhalts deiner Seite ein. Diese Beschreibung wird in den Suchergebnissen von Suchmaschinen wie Google unter dem Titel deiner Seite angezeigt.",
  wb_add_page_dialog_type_page_path_label:
    "Adresse nach Domäne z.B. Dienstleistungen",
  wb_add_page_dialog_type_page_path_blog_label:
    "Adresse nach der Domain z.B. Blog",
  wb_add_page_dialog_type_main_page: "Startseite",
  wb_add_page_dialog_type_page: "Unterseite",
  wb_add_page_dialog_type_redirect: "Umleitung (externer Link)",
  wb_add_page_dialog_type_blog_handy: "Blog",
  wb_add_page_dialog_type_redirect_url: "Umleitung der Webadresse",
  wb_add_page_dialog_type_blog_handy_id:
    "BlogHandy Id z.B. 609wl61ZYL0ArTAFR23",
  wb_blog_handy_description:
    "BlogHandy ist eine externe Plattform, die es dir ermöglicht, einfach einen Blog zu führen. BlogHandy kann einfach mit der www-Seite in Calendesk integriert werden.",
  wb_blog_handy_info_1:
    "Um einen Blog zu deiner Calendesk-Seite hinzuzufügen, befolge die unten stehenden Anweisungen:",
  wb_blog_handy_info_2:
    "Klicke unten und registriere dich auf der BlogHandy-Plattform.",
  wb_blog_handy_info_3:
    "Kopiere den Blog-Identifier von deinem BlogHandy-Konto und füge ihn in das unten stehende Feld ein.",
  wb_blog_handy_info_4:
    "Herzlichen Glückwunsch! 🎉 Jeder Blogbeitrag, der auf BlogHandy veröffentlicht wird, erscheint automatisch auf deiner Calendesk-Seite.",
  wb_blog_handy_signup_button_title: "Registriere dich bei BlogHandy",
  wb_general: "Allgemein",
  wb_style: "Stil",
  wb_section: "Seitenabschnitt",
  wb_color_primary: "Schaltflächen und wichtige Elemente",
  wb_color_bg: "Erster Hintergrund",
  wb_color_text: "Text auf dem ersten Hintergrund",
  wb_color_bg_2: "Zweiter Hintergrund",
  wb_color_text_2: "Text auf dem zweiten Hintergrund",
  wb_google_tag_id: "Google Tag ID",
  wb_website_description: "Beschreibung der Seite für Robots (SEO)\n",
  wb_title: "Überschrift",
  wb_text: "Inhalt",
  wb_subtitle: "Untertitel",
  wb_description: "Beschreibung",
  wb_image: "Grafik",
  wb_image_1: "Grafik 1",
  wb_image_2: "Grafik 2",
  wb_image_3: "Grafik 3",
  wb_image_4: "Grafik 4",
  wb_background: "Hintergrund",
  wb_category_section_navbar_1: "Überschrift mit Logo",
  wb_category_section_navbar_2: "Überschrift ohne Logo",
  wb_category_section_footer: "Fußzeile",
  wb_category_section_employees: "Mitarbeiter",
  wb_category_section_services: "Dienstleistungen",
  wb_category_section_booking: "Termin buchen",
  wb_category_section_about_us: "Über uns",
  wb_category_section_feature: "Universal",
  wb_category_section_review: "Optionen",
  wb_category_section_other: "Andere",
  wb_category_section_header: "Überschrift",
  wb_category_section_newsletter: "Newsletter",
  wb_category_section_form: "Kontaktformular",
  wb_category_section_cta: "Aufruf zum Handeln (CTA)",
  wb_decrease_section: "Verkleinern",
  wb_increase_section: "Vergrößern",
  wb_company_name: "Unternehmensname",
  wb_login_modal: "Anmeldung",
  wb_login_subtitle: "Untertitel",
  wb_sign_up: "Konto erstellen",
  wb_login: "Einloggen",
  wb_sign_up_modal: "Registrierung",
  wb_menu_bookings: "Buchungen",
  wb_menu_payments: "Zahlungen",
  wb_menu_settings: "Einstellungen",
  wb_menu_logout: "Abmelden",
  wb_forgotten_password_modal: "Passwort erinnern",
  wb_forgotten_password_confirmation_modal: "E-Mail-Bestätigungen",
  wb_forgotten_password_title: "Titel",
  wb_forgotten_password_subtitle: "Untertitel",
  wb_submit_button: "Schaltfläche Bestätigen",
  wb_forgotten_password_modal_confirmation_title: "Titel",
  wb_forgotten_password_modal_confirmation_subtitle: "Untertitel",
  wb_company_address: "Adresse",
  wb_company_email: "E-Mail-Adresse",
  wb_company_phone: "Telefon",
  wb_menu_title: "Menü Titel",
  wb_account_title: "Profil",
  wb_signup: "Registieren",
  wb_profile: "Buchungen",
  wb_settings: "Einstellungen",
  wb_company_slogan: "Schlagwort",
  wb_service_label: "Dienstleistungsetikett",
  wb_employee_label: "Mitarbeiter-Etikette",
  wb_employee_info_label: "Text über dem Mitarbeiterfeld",
  wb_booking_button: "Schaltfläche Buchung",
  wb_page_list: "Menü Bearbeiten",
  wb_menu_column_1: "Menü 1",
  wb_menu_column_2: "Menü 2",
  wb_publish_confirm_dialog_title: "Soll die Website veröffentlicht werden?",
  wb_publish_confirm_dialog_text:
    "Die Website wird innerhalb einer Minute online sein.",
  wb_publish_success_text:
    "Herzlichen Glückwunsch! Deine Website wird in kürzester Zeit online sein.",
  wb_more_pages_button: "Weitere Seiten",
  wb_sign_up_terms_info:
    "Soll der Vermerk über die Annahme der Allgemeinen Geschäftsbedingungen angezeigt werden?",
  wb_select_data_label: "Datum auswählen",
  wb_edit_page: "Seite bearbeiten",
  wb_remove_page_confirm_dialog_title: "Soll die Website gelöscht werden?",
  wb_remove_page_confirm_dialog_text: "Die Seite wird gelöscht.",
  wb_remove_page_success_text: "Die Seite wurde gelöscht.",
  wb_remove_confirm_dialog_title: "Bist du ganz sicher?",
  wb_remove_confirm_dialog_text:
    "Diese Änderung kann nicht rückgängig gemacht werden!",
  wb_remove_success_text: "Löschung erfolgreich abgeschlossen",
  wb_employees_title: "Unser Team",
  wb_employees_no_data:
    "Füge Mitarbeiter im Calendesk-Bedienfeld hinzu, um eine Vorschau zu sehen.",
  wb_services_no_data:
    "Füge im Calendesk-Panel Dienstleistungen hinzu, um eine Vorschau zu sehen.",
  wb_employee_list: "Spezialisten",
  wb_service_list: "Dienstleistungen",
  wb_items_selector_info: "Klicke unten, um Elemente hinzuzufügen",
  wb_change: "Ersetzen",
  wb_replace_navbar: "Kopfzeile ersetzen",
  wb_replace_footer: "Fußzeile ersetzen",
  wb_main_pages_number: "Anzahl der Hauptregisterkarten",
  wb_button: "Schaltfläche",
  wb_sign_in_button: "Anmelde-Button",
  wb_sign_up_button: "Registrierungs-Button",
  wb_domain_example: "z.B. meinefirma.de",
  wb_no_domain_info: "Die Domäne wurde nicht eingerichtet",
  wb_book_online: "Schaltfläche Buchung",
  wb_button_title: "Schaltfläche",
  wb_select_subpage: "Unterseite",
  wb_features: "Eigenschaften",
  wb_add_button: "Schaltfläche hinzufügen",
  wb_new_button: "Neue Schaltfläche",
  wb_button_edit_menu_redirect: "Umleitung auswählen",
  wb_button_edit_menu_style: "Stil und Größe einstellen",
  wb_button_outlined: "Umriss",
  wb_button_rounded: "Abgerundet",
  wb_button_size: "Größe",
  wb_button_dark: "Dunkel",
  wb_redirect: "Umleitung",
  wb_add_sections_feature: "Element hinzufügen",
  wb_dummy_text_about_us: "Über uns",
  wb_dummy_text_service: "Dienstleistung",
  wb_dummy_text_select_service: "Dienstleistung auswählen",
  wb_dummy_text_select_employee: "Person auswählen",
  wb_dummy_text_select_location: "Standort wählen",
  wb_dummy_selected_services: "Ausgewählte Dienstleistungen",
  wb_dummy_text_select_date: "Datum wählen",
  wb_dummy_text_select_date_and_hour: "Datum und Zeit wählen",
  wb_dummy_text_first_available: "Nächster freier Termin: heute",
  wb_dummy_text_address: "Musterstraße 1",
  wb_dummy_text_services: "Unsere Dienstleistungen",
  wb_dummy_text_book_now: "Buchen",
  wb_dummy_text_employees: "Unser Team",
  wb_dummy_text_more: "Mehr anzeigen",
  wb_dummy_text_buy_now: "Jetzt kaufen",
  wb_dummy_text_regulations: "Allgemeine Bestimmungen",
  wb_dummy_text_privacy_policy: "Datenschutzbestimmungen",
  wb_dummy_text_reviews_title: "Feedback unserer Kunden",
  wb_dummy_text_reviews_full_name: "Max Mustermann",
  wb_dummy_text_review_example:
    "Dieser Ort ist ein echter Hammer, ich nutze ihre Dienste schon seit langem und sie überraschen mich immer noch! Ich kann es nur empfehlen :)",
  wb_dummy_text_booking_title:
    "Buche einen Termin bei uns in wenigen Minuten, ohne dein Haus zu verlassen und komplett online.",
  wb_dummy_text_1:
    "Moderner Ort in der Mitte Berlins. Immer für dich da! Bei uns arbeiten nur die Besten der Besten. Wir vergessen nicht, uns weiterzubilden und Wissen zu erwerben, das wir später an dich weitergeben können. Begib dich in unsere Hände. Wir verwenden modernste Methoden. Du kannst einen Termin komplett online vereinbaren - nutze einfach die mobile App, wo du die wichtigsten Informationen von uns erhalten.",
  wb_dummy_text_2:
    "Erkunde die Möglichkeiten, die dir unsere Dienstleistungen bieten",
  wb_dummy_text_3: "Was bieten wir an?",
  wb_dummy_text_4: "Worüber würdest du gerne sprechen?",
  wb_dummy_text_5: "Bitte gib deinen Namen unten ein",
  wb_dummy_text_6:
    "Dies ist ein Beispiel für eine Dienstleistungsbeschreibung. Du legst sie im Calendesk Administrationsbereich fest, wenn du die Dienstleistungen bearbeiten. Du kannst einen beliebigen Text für verschiedene Angebote wählen.",
  wb_dummy_text_title: "Beispieltext",
  wb_dummy_subject_title: "Nachricht aus dem Formular auf der Website",
  wb_dummy_form_sent_success_title:
    "Vielen Dank, das Formular wurde korrekt übermittelt.",
  wb_dummy_form_sent_success_description:
    "Wir werden dich so bald wie möglich kontaktieren.",
  wb_dummy_text_newsletter_1:
    "Informationen über neue Dienstleistungen und Produkte direkt an deine E-Mail-Adresse",
  wb_dummy_text_newsletter_2:
    "Abonniere unseren Newsletter, um auf dem Laufenden zu bleiben",
  wb_dummy_text_newsletter_3: "Abonnieren",
  wb_dummy_text_newsletter_4: "E-Mail-Adresse",
  wb_dummy_text_newsletter_5:
    "Herzlichen Dank! Ein Aktivierungslink wurde an deine E-Mail-Adresse gesendet.",
  wb_dummy_text_newsletter_6: "Mehr als du glaubst",
  wb_regulations_info:
    "Der Inhalt der Allgemeinen Bedingungen kann im Calendesk-Panel unter Einstellungen / Dein Unternehmen bearbeitet werden.",
  wb_privacy_policy_info:
    "Der Inhalt der Datenschutzrichtlinie kann im Calendesk-Panel unter Einstellungen / Dein Unternehmen bearbeitet werden.",
  wb_regulations_page: "Seite der Allgemeinen Bedingungen",
  wb_privacy_policy_page: "Seite zur Datenschutzpolitik",
  wb_login_enabled: "Anmeldung ist aktiv",
  wb_booking_confirmation: "Buchungsbestätigung",
  wb_booking_created_summary: "Bestätigung des Nachrichtenversands",
  wb_booking_created_payment_summary: "Informationen zur Zahlungspflicht",
  wb_creator_chat_1:
    "Hallo &#128075;. Ich bin dein virtueller Webdesign-Assistent. Ich kann dir helfen, deine Website in wenigen Minuten einzurichten.",
  wb_creator_chat_2: "Wähle deine Branche",
  wb_creator_chat_3:
    "Herzlichen Dank! Der erste Schritt ist getan &#128588;. Nun ist es an der Zeit, die Elemente auszuwählen, die auf deiner neuen Website erscheinen sollen.",
  wb_creator_chat_4:
    "Wähle den Stil aus, der auf die Seite angewendet werden soll. Die Farben können später beliebig geändert werden.",
  wb_creator_chat_5:
    "Es ist fast fertig! Du kannst mehrere Entwürfe der Seite haben und sie nach Bedarf ändern &#129321;. Wie soll die aktuelle Skizze genannt werden?",
  wb_creator_chat_6:
    "Erledigt &#128079;! Das hast du großartig gemacht. Die Seite wird gerade vorbereitet, gib mir eine Minute.... &#128640;&#128640;",
  wb_creator_chat_6a: "Es wird großartig sein &#129321;",
  wb_creator_chat_6b: "Ich bin fast fertig ...",
  wb_creator_chat_6c: "Nur noch ein paar Codezeilen und fertig ...",
  wb_select_draft_name:
    "Wie soll der aktuelle Entwurf der Seite genannt werden?",
  wb_draft_name_text_field_label: "Website Name",
  wb_chat_with_us: "Support-Chat",
  wb_selected_n_items: "Ausgewählte Elemente: @{amount}.",
  wb_business_1: "Friseursalon",
  wb_business_2: "Wellness-Salon",
  wb_business_3: "Beauty-Salon",
  wb_business_4: "Diätassistent/in",
  wb_business_5: "Nachhilfe",
  wb_business_6: "Kinderbetreuung",
  wb_business_7: "Geschäftliche Termine",
  wb_business_8: "Magistrat",
  wb_business_9: "Finanzdienstleistungen",
  wb_business_10: "Escape room",
  wb_business_11: "Juristische Dienstleistungen",
  wb_business_12: "Medizin",
  wb_business_13: "Fahrschule",
  wb_business_14: "Fotostudio",
  wb_business_15: "Psychologe/-in",
  wb_business_16: "Beratungsleistungen",
  wb_business_17: "Coaching",
  wb_business_18: "Tierpflege",
  wb_business_19: "Innenarchitektur",
  wb_business_20: "Reinigungsdienstleistungen",
  wb_business_21: "Sport",
  wb_business_22: "Personal Trainer",
  wb_business_23: "Fitnessstudio",
  wb_business_24: "Fitness",
  wb_business_25: "Yoga",
  wb_business_26: "Tennisklub",
  wb_business_27: "Veranstaltungsorte",
  wb_business_28: "Restaurant",
  wb_business_29: "Physiotherapie",
  wb_business_30: "Sonstiges",
  wb_website_element_1: "Anmeldung und Registrierung von Kunden",
  wb_website_element_2: "Online Buchungen",
  wb_website_element_3: "Dienstleistungen",
  wb_website_element_4: "Über uns",
  wb_website_element_5: "Team",
  wb_website_element_6:
    "Allgemeine Geschäftsbedingungen und Datenschutzerklärung",
  wb_website_element_7: "Bildergalerie",
  wb_website_element_8: "Newsletter",
  wb_website_element_tooltip_1:
    "Wir ermöglichen deinen Kunden, ein Konto zu erstellen und sich einzuloggen.",
  wb_website_element_tooltip_2:
    "Es wird ein Abschnitt für Online-Buchungen hinzugefügt.",
  wb_website_element_tooltip_3:
    "Ein Abschnitt und eine Unterseite mit deinen Dienstleistungen werden hinzugefügt.",
  wb_website_element_tooltip_4:
    "Ein Abschnitt mit Informationen über dein Unternehmen wird hinzugefügt.",
  wb_website_element_tooltip_5:
    "Ein Abschnitt und eine Unterseite mit deinen Mitarbeitern werden hinzugefügt.",
  wb_website_element_tooltip_6:
    "Es wird eine Unterseite mit den Nutzungsbedingungen und der Datenschutzerklärung hinzugefügt. Das Ganze wird aus dem Calendesk-Panel heruntergeladen.",
  wb_website_element_tooltip_7:
    "Ein Abschnitt mit Fotogalerie wird hinzugefügt.",
  wb_website_element_tooltip_8: "Ein Newsletter-Abschnitt wird hinzugefügt.",
  wb_website_style_1: "Seesturm",
  wb_website_style_2: "Meeresstahl",
  wb_website_style_3: "Pastellpulver",
  wb_website_style_4: "Nebliger Mohn",
  wb_website_style_5: "Waldwelt",
  wb_website_style_6: "Honig Dämmerung",
  wb_website_style_7: "Sonniges Lächeln",
  wb_website_style_8: "Roter Kuss",
  wb_website_style_9: "Gesundes Grün",
  wb_website_style_10: "Regenwolke",
  wb_website_style_11: "Blaubeeren in Schokolade",
  wb_website_style_12: "Orangenstaub",
  wb_draft_name_example: "Meine Seite - @{template}",
  wb_default_login_text: "Du musst eingeloggt sein, um einen Termin zu buchen.",
  wb_default_forgotten_password_title: "Manchmal vergisst jeder sein Passwort",
  wb_default_forgotten_password_subtitle:
    "Gib die E-Mail-Adresse ein, die du bei der Registrierung verwendet haben, um Anweisungen zur Änderung deines Passworts zu erhalten.",
  wb_default_forgotten_password_modal_confirmation_title:
    "E-Mail-Posteingang prüfen",
  wb_default_forgotten_password_modal_confirmation_subtitle:
    "Wenn die E-Mail-Adresse im System vorhanden ist, wurde soeben eine E-Mail mit Anweisungen zum Ändern des Passworts an diese Adresse gesendet.",
  wb_default_booking_created_summary:
    "Eine Buchungsbestätigung wurde an deine E-Mail-Adresse geschickt.",
  wb_default_address: "Berlin, Hauptstraße 1, 10101",
  wb_default_email: "hans.bauer@calendesk.com",
  wb_default_product_name: "Beispielprodukt",
  wb_default_product_description: "Dies sind zusätzliche Produktinformationen.",
  wb_default_phone: "+49 22 200 20 20",
  wb_default_menu_title: "Menü",
  wb_default_profile_title: "Profil",
  wb_main_page_name: "Startseite",
  wb_main_page_url: "Startseite",
  wb_employees_page_name: "Über uns",
  wb_team_page_name: "Unser Team",
  wb_employees_page_url: "über-uns",
  wb_team_page_url: "unser-Team",
  wb_services_page_name: "Dienstleistungen",
  wb_services_page_name_2: "Angebot",
  wb_services_page_url: "Dienstleistungen",
  wb_services_page_url_2: "Angebot",
  wb_regulations_page_name: "Allgemeine Bestimmungen",
  wb_regulations_page_url: "allgemeine Bestimmungen",
  wb_privacy_policy_page_name: "Datenschutzerklärung",
  wb_privacy_policy_page_url: "Datenschutzerklärung",
  wb_dark_mode: "Dark Mode",
  wb_facebook: "Facebook-URL",
  wb_instagram: "Instagram-URL",
  wb_twitter: "X-URL",
  wb_youtube: "YouTube-URL",
  wb_section_missing_question:
    "Fehlender Abschnitt? Schreibe uns, wir werden es für dich machen!",
  wb_employees_select_section_info:
    "Die Beschreibungen der Mitarbeiter und ihre Fotos können im Calendesk-Panel bearbeitet werden.",
  wb_edit_employees_button_title: "Mitarbeiter bearbeiten",
  wb_services_select_section_info:
    "Die Beschreibungen und Bilder der Dienstleistungen können im Calendesk-Panel bearbeitet werden.",
  wb_edit_services_button_title: "Dienstleistungen bearbeiten",
  wb_reload_button_title: "Neu laden",
  wb_category_section_photo_gallery: "Bildergalerie",
  wb_hide_arrows: "Pfeile verstecken",
  wb_hide_delimiters: "Die Schalter verstecken",
  wb_interval: "Geschwindigkeit der Änderung in Millisekunden",
  wb_cycle: "Automatisches Umschalten",
  wb_invert_colors: "Farben invertieren",
  wb_website_disabled_success:
    "Die Website wurde deaktiviert und wird in wenigen Minuten nicht mehr im Internet zu finden sein.",
  wb_set_as_main_website: "Als Hauptwebsite festlegen",
  wb_set_as_main_website_success: "Die Hauptseite wurde korrekt eingerichtet.",
  wb_main_website: "Startseite",
  new_content_available:
    'Die Seite wurde aktualisiert. Klicke auf "Aktualisieren", um die Seite neu zu laden.',
  refresh_button_title: "Neu laden",
  wb_newsletter_input_placeholder: "Tipp",
  wb_newsletter_success_message: "Nachricht zum Senden eines Links",
  newsletter_delete_success:
    "Die ausgewählten Datensätze wurden korrekt gelöscht",
  remove_newsletter_record: "E-Mail-Adresse löschen",
  remove_newsletter_records: "E-Mail-Adressen löschen",
  verified_at: "Verifiziert",
  email_is_valid: "E-Mail-Adresse bestätigt",
  email_is_not_valid: "E-Mail nicht bestätigt",
  newsletters: "Newsletter",
  push: "Push",
  push_tooltip: "Der Benutzer verwendet die mobile App",
  send_customer_notification_title: "Nachricht an Kunden senden",
  send_customers_notification_title: "Nachricht an die Kunden senden",
  send_employee_notification_title: "Nachricht an den Mitarbeiter senden",
  send_employees_notification_title: "Nachricht an die Mitarbeiter senden",
  send_customer_notification_number_info: "Empfängeranzahl",
  notification_type_1: "E-Mail",
  notification_type_2: "SMS",
  notification_type_3: "Push-Benachrichtigung",
  notification_type_title: "Benachrichtigungstyp",
  notification_category_title: "Benachrichtigungskategorie",
  notification_subject: "Titel",
  notification_content: "Inhalt",
  send: "Senden",
  send_customer_notification_confirm_title:
    "Bist du sicher, dass du eine Nachricht an ausgewählte Personen senden möchtest?",
  send_customer_notification_confirm_info:
    "Du sendest eine Nachricht Typ  „@{type}”. Anzahl der Empfänger: @{amount}.",
  download_csv_title: "CSV herunterladen",
  download_vcf_title: "VCF herunterladen (vCard)",
  download_xlsx_title: "XLSX herunterladen (Microsoft Excel)",
  download_xls_title: "XLS herunterladen (Microsoft Excel)",
  download_ods_title: "ODS herunterladen (Open Office, LibreOffice)",
  download_html_title: "HTML herunterladen",
  customer_notifications: "Verlauf",
  customer_type: "Empfänger",
  customer_type_1: "Kunde",
  customer_type_2: "Newsletter",
  customer_type_3: "Mitarbeiter",
  customer_type_4: "Extern",
  customer_type_5: "Unternehmen",
  recipients_count_title: "Empfängeranzahl",
  display_customer_notification_title: "Vorschau der Nachricht",
  expand: "Erweitern",
  collapse: "Weniger",
  reverse_charge_info:
    "Die MwSt. wird in der Rechnung nicht ausgewiesen (Reverse Charge).",
  reverse_charge_info_2:
    "Bei der Umkehrung der Steuerschuldnerschaft ist die Mehrwertsteuer zu entrichten.",
  employees_premium_banner_title: "Das Limit wurde erreicht",
  employees_premium_banner_description:
    "Wechsle zu einem höheren Tarif, um neue Kunden ohne Einschränkungen hinzufügen zu können.",
  users_premium_banner_title: "Das Limit wurde erreicht",
  users_premium_banner_description:
    "Wechsle zu einem höheren Tarif, um neue Kunden ohne Einschränkungen hinzufügen zu können.",
  google_calendar: "Google Kalender",
  google_meet: "Google Meet",
  google_meet_description:
    "Lege den Standort deiner Dienstleistung auf Google Meet in Calendesk fest, damit das Calendesk-System bei jeder Buchung einen individuellen Link zu dem Termin erstellt. Der Link wird an dich und deinen Kunden weitergeleitet, sobald die Buchung erstellt wurde.",
  google_calendar_connect_info:
    "Klicke unten, um deinen Google-Kalender mit dem Calendesk-Kalender zu verknüpfen. Sobald die Verknüpfung hergestellt ist, werden alle deine Termine und deren Änderungen an deinen Google-Kalender gesendet. Denke daran, dass der Kalender nur in eine Richtung funktioniert. Wenn du einen Besuch im Google-Kalender ändern, wird diese Änderung nicht in Calendesk angezeigt. Nimm alle Änderungen immer über Calendesk vor.",
  google_calendar_disconnect_info:
    "Die Synchronisierung mit Google Calendar ist aktiv. Klicke unten, um die Verbindung zu trennen.",
  disconnect_button_title: "Trennen",
  plugin_only_for_employees_info:
    "Das Modul funktioniert nur mit einem Mitarbeiterkonto. Du musst ein Mitarbeiterkonto anlegen, um Buchungen annehmen zu können.",
  plugin_not_active_employee_info:
    "Das Modul ist nicht aktiv. Wende dich an den Administrator, um das Modul zu aktivieren.",
  google_calendar_auth_success_title: "Korrekte Google-Autorisierung",
  google_calendar_disconnect_dialog_title: "Google Kalender trennen",
  google_calendar_disconnect_dialog_info:
    "Bist du sicher, dass du die Verbindung zu Google Calendar trennen möchtest? Deine zukünftigen Calendesk-Besuche und -Sperren werden nicht mehr an Google Calendar gesendet.",
  google_calendar_disconnect_success_message:
    "Die Verbindung zum Kalender wurde korrekt getrennt.",
  buy: "Kaufen",
  plan_expired_title: "Dein aktueller Plan ist abgelaufen",
  building_plans_title:
    "Wir aktivieren alle Funktionen, die du benötigst &#128640;&#128640;!",
  building_plans_subtitle:
    "Es wird nicht länger als ein paar Sekunden dauern ...",
  go_to_summary: "Zur Zusammenfassung gehen",
  cd_base_standard: "Calendesk Standard",
  cd_base_pro: "Calendesk Pro",
  cd_base_enterprise: "Calendesk Enterprise",
  plans_description_standard:
    "Nutze die Möglichkeiten von Calendesk, um dein Geschäft zu verbessern.",
  plans_description_pro:
    "Für die Anspruchsvollsten, die auf Wachstum ausgerichtet sind.",
  plans_description_enterprise:
    "Volle Flexibilität, kontaktiere uns für weitere Informationen.",
  enterprise_price_list_info: "Einzelvertrag mit jährlicher Abrechnung",
  plans_billed_annually: "jährlich abgerechnet",
  plans_or: "oder",
  plans_month_to_month_payment: "monatlich abgerechnet",
  plans_featured: "Die meistgewählten",
  plans_feature_name_2: "Anzahl der Webseiten",
  plans_feature_standard_2: "Maximal 1 Webseite",
  plans_feature_standard_2_tooltip:
    "Möglichkeit, 1 Website mit einer beliebigen Anzahl von Unterseiten für dein Unternehmen zu erstellen.",
  plans_feature_pro_2: "Maximal 3 Webseiten",
  plans_feature_pro_2_tooltip:
    "Möglichkeit, 3 dedizierte Websites zu erstellen, mit einer unbegrenzten Anzahl von Unterseiten für die verschiedenen Dienstleistungen, die du anbietest (z. B. unter SEO und SEM).",
  plans_feature_enterprise_2: "Unbegrenzt",
  plans_feature_enterprise_2_tooltip:
    "Die Möglichkeit, eine unbegrenzte Anzahl von Seiten für verschiedene Dienstleistungen und verschiedene Kunden zu erstellen - z. B. Seiten für einzelne Kunden, für Unternehmen, die ein bestimmtes Produkt oder eine Dienstleistung bewerben, Seiten für Facebook und spezielle Seiten für Suchmaschinen (SEO und SEM).",
  plans_feature_name_4: "5 GB Dateispeicherplatz für Kunden",
  plans_feature_standard_4: "Nein",
  plans_feature_standard_4_tooltip:
    "Diese Option ist ab dem Pro-Tarif verfügbar.",
  plans_feature_pro_4: "Ja",
  plans_feature_pro_4_tooltip:
    "Kunden können während des Buchungsprozesses Dateien wie PDFs, Textdokumente, Excel-Tabellen, Bilder und Fotos hochladen.",
  plans_feature_enterprise_4: "Ja",
  plans_feature_enterprise_4_tooltip:
    "Kunden können während des Buchungsprozesses Dateien wie PDFs, Textdokumente, Excel-Tabellen, Bilder und Fotos hochladen.",
  plans_feature_name_5: "E-Mail Benachrichtigungen",
  plans_feature_standard_5: "500 Stück pro Monat",
  plans_feature_standard_5_tooltip:
    "Sende deinen Kunden Buchungs-E-Mails (Bestätigung der Terminannahme, -änderung oder -stornierung), Transaktions-E-Mails, Benachrichtigungen und Sonderangebote.",
  plans_feature_pro_5: "1.000 Stück pro Monat",
  plans_feature_pro_5_tooltip:
    "Sende deinen Kunden Buchungs-E-Mails (Bestätigung der Terminannahme, -änderung oder -stornierung), Transaktions-E-Mails, Benachrichtigungen und Sonderangebote.",
  plans_feature_enterprise_5: "Unbegrenzt",
  plans_feature_enterprise_5_tooltip:
    "Sende deinen Kunden Buchungs-E-Mails (Bestätigung der Terminannahme, -änderung oder -stornierung), Transaktions-E-Mails, Benachrichtigungen und Sonderangebote.",
  plans_feature_name_6: "Das E-Mail-Paket vergrößern",
  plans_feature_standard_6: "Ja",
  plans_feature_standard_6_tooltip:
    "Jede beliebige Menge kann für 0,02 € pro E-Mail erworben werden.",
  plans_feature_pro_6: "Ja",
  plans_feature_pro_6_tooltip:
    "Jede beliebige Menge kann für 0,01 € pro E-Mail erworben werden.",
  plans_feature_enterprise_6: "Ja",
  plans_feature_enterprise_6_tooltip:
    "Jede beliebige Anzahl kann zu einem individuell festgelegten Preis erworben werden.",
  plans_feature_name_7: "SMS-Benachrichtigungen",
  plans_feature_standard_7: "50 Stück pro Monat",
  plans_feature_standard_7_tooltip:
    "Sende deinen Kunden SMS-Nachrichten - bestätige eine Buchung, eine Terminänderung oder eine Stornierung, informiere sie über Werbeaktionen, Sonderangebote und Rabatte.",
  plans_feature_pro_7: "100 Stück pro Monat",
  plans_feature_pro_7_tooltip:
    "Sende deinen Kunden SMS-Nachrichten - bestätige eine Buchung, eine Terminänderung oder eine Stornierung, informiere sie über Werbeaktionen, Sonderangebote und Rabatte.",
  plans_feature_enterprise_7: "Unbegrenzt",
  plans_feature_enterprise_7_tooltip:
    "Sende deinen Kunden SMS-Nachrichten - bestätige eine Buchung, eine Terminänderung oder eine Stornierung, informiere sie über Werbeaktionen, Sonderangebote und Rabatte.",
  plans_feature_name_8: "Das SMS-Paket vergrößern",
  plans_feature_standard_8: "Ja",
  plans_feature_standard_8_tooltip:
    "Du kannst so viele SMS kaufen, wie du möchtest, für 0,07 € pro SMS + ein spezielles Paket mit 200 SMS pro Monat für 7,99 €.",
  plans_feature_pro_8: "Ja",
  plans_feature_pro_8_tooltip:
    "Du kannst beliebig viele SMS für 0,06 € pro SMS kaufen + PREMIUM-Paket mit 250 Stück pro Monat für 7,99 €.",
  plans_feature_enterprise_8: "Ja",
  plans_feature_enterprise_8_tooltip:
    "Du kannst eine gewünschte Anzahl zu einem individuell festgelegten Preis kaufen.",
  plans_feature_name_12: "Google Kalender Integration",
  plans_feature_standard_12: "Ja",
  plans_feature_standard_12_tooltip:
    "Kontrolliere Termine in Echtzeit, exportiere alle Buchungen, Aufträge und Termine in den Google Kalender. Mach die ausgewählten Ereignisse für deine Mitarbeiter und Kunden sichtbar. Erleichtere ihnen das Leben und steigere die Effizienz deines Unternehmens.",
  plans_feature_pro_12: "Ja",
  plans_feature_pro_12_tooltip:
    "Kontrolliere Termine in Echtzeit, exportiere alle Buchungen, Aufträge und Termine in den Google Kalender. Mach die ausgewählten Ereignisse für deine Mitarbeiter und Kunden sichtbar. Erleichtere ihnen das Leben und steigere die Effizienz deines Unternehmens.",
  plans_feature_enterprise_12: "Ja",
  plans_feature_enterprise_12_tooltip:
    "Kontrolliere Termine in Echtzeit, exportiere alle Buchungen, Aufträge und Termine in den Google Kalender. Mach die ausgewählten Ereignisse für deine Mitarbeiter und Kunden sichtbar. Erleichtere ihnen das Leben und steigere die Effizienz deines Unternehmens.",
  plans_feature_name_14: "Newsletter",
  plans_feature_standard_14: "Ja",
  plans_feature_standard_14_tooltip:
    "Erstelle einen einfachen Newsletter für den Kunden - erinnere ihn an deine Dienstleistungen, biete Rabatte, Werbeaktionen und zusätzliche Dienstleistungen an.",
  plans_feature_pro_14: "Ja",
  plans_feature_pro_14_tooltip:
    "Erstelle einen einfachen Newsletter für den Kunden - erinnere ihn an deine Dienstleistungen, biete Rabatte, Werbeaktionen und zusätzliche Dienstleistungen an.",
  plans_feature_enterprise_14: "Ja",
  plans_feature_enterprise_14_tooltip:
    "Erstelle einen einfachen Newsletter für den Kunden - erinnere ihn an deine Dienstleistungen, biete Rabatte, Werbeaktionen und zusätzliche Dienstleistungen an.",
  plans_feature_name_18: "Anzahl der Buchungen",
  plans_feature_standard_18: "750 Buchungen pro Monat",
  plans_feature_standard_18_tooltip:
    "Bearbeitung von bis zu 750 Buchungen pro Monat.",
  plans_feature_pro_18: "2.500 Buchungen pro Monat",
  plans_feature_pro_18_tooltip:
    "Bearbeitung von maximal 2.500 Buchungen pro Monat.",
  plans_feature_enterprise_18: "Unbegrenzt",
  plans_feature_enterprise_18_tooltip:
    "Kein Limit für die Anzahl der Buchungen.",
  plans_feature_name_19: "Anzahl der Mitarbeiterkonten",
  plans_feature_standard_19: "5 Mitarbeiterkonten",
  plans_feature_standard_19_tooltip:
    "Begrenzt zu 5 App-Benutzern - Möglichkeit, Rollen und Zugriffsrechte auf einfache Weise festzulegen.",
  plans_feature_pro_19: "15 Mitarbeiterkonten",
  plans_feature_pro_19_tooltip:
    "Begrenzt zu 15 App-Benutzern - Möglichkeit, Rollen und Zugriffsrechte auf einfache Weise festzulegen.",
  plans_feature_enterprise_19: "Unbegrenzt",
  plans_feature_enterprise_19_tooltip:
    "Keine Begrenzung der Anzahl der unterstützten Konten - unbegrenzte Rollen und mehrere Zugriffsrechte. Die Anzahl der unterstützten Konten wird individuell festgelegt.",
  plans_feature_name_20: "Generator für Datenschutzerklärung und AGB",
  plans_feature_standard_20: "Ja",
  plans_feature_standard_20_tooltip:
    "Erstelle Dokumente mit der gemeinsam mit unseren Anwälten erstellten App.",
  plans_feature_pro_20: "Ja",
  plans_feature_pro_20_tooltip:
    "Erstelle Dokumente mit der gemeinsam mit unseren Anwälten erstellten App.",
  plans_feature_enterprise_20: "Ja",
  plans_feature_enterprise_20_tooltip:
    "Erstelle Dokumente mit der gemeinsam mit unseren Anwälten erstellten App.",
  plans_feature_name_21: "Google Meet Integration",
  plans_feature_standard_21: "Ja",
  plans_feature_standard_21_tooltip:
    "Erstelle einen Google Meet-Link, sobald du buchst.",
  plans_feature_pro_21: "Ja",
  plans_feature_pro_21_tooltip:
    "Erstelle einen Google Meet-Link, sobald du buchst.",
  plans_feature_enterprise_21: "Ja",
  plans_feature_enterprise_21_tooltip:
    "Erstelle einen Google Meet-Link, sobald du buchst.",
  plans_feature_name_22: "Integration des Rechnungsshops",
  plans_feature_standard_22: "Ja",
  plans_feature_standard_22_tooltip:
    "Stelle deinem Kunden sofort nach der Zahlung eine MwSt.-Rechnung aus.",
  plans_feature_pro_22: "Ja",
  plans_feature_pro_22_tooltip:
    "Stelle deinem Kunden sofort nach der Zahlung eine MwSt.-Rechnung aus.",
  plans_feature_enterprise_22: "Ja",
  plans_feature_enterprise_22_tooltip:
    "Stelle deinem Kunden sofort nach der Zahlung eine MwSt.-Rechnung aus.",
  plans_feature_name_23: "Zoom Integration",
  plans_feature_standard_23: "Ja",
  plans_feature_standard_23_tooltip:
    "Erstelle einen Link zum Zoom-Meeting gleich nach der Buchung.",
  plans_feature_pro_23: "Ja",
  plans_feature_pro_23_tooltip:
    "Erstelle einen Link zum Zoom-Meeting gleich nach der Buchung.",
  plans_feature_enterprise_23: "Ja",
  plans_feature_enterprise_23_tooltip:
    "Erstelle einen Link zum Zoom-Meeting gleich nach der Buchung.",
  plans_feature_name_24: "Zapier Integration",
  plans_feature_standard_24: "Nein",
  plans_feature_standard_24_tooltip:
    "Diese Option ist ab dem Pro-Tarif verfügbar.",
  plans_feature_pro_24: "Ja",
  plans_feature_pro_24_tooltip:
    "Verbinde deine Apps und automatisiere deine Arbeitsabläufe.",
  plans_feature_enterprise_24: "Ja",
  plans_feature_enterprise_24_tooltip:
    "Verbinde deine Apps und automatisiere deine Arbeitsabläufe.",
  plans_feature_name_25: "API-Zugriff",
  plans_feature_standard_25: "Nein",
  plans_feature_standard_25_tooltip:
    "Diese Option ist ab dem Pro-Tarif verfügbar.",
  plans_feature_pro_25: "Ja",
  plans_feature_pro_25_tooltip:
    "Verwende die in Calendesk gespeicherten Daten in allen Apps, mit denen du arbeitest.",
  plans_feature_enterprise_25: "Ja",
  plans_feature_enterprise_25_tooltip:
    "Verwende die in Calendesk gespeicherten Daten in allen Apps, mit denen du arbeitest.",
  plans_feature_name_27: "Anzahl der einzelnen Seitenaufrufe pro Monat",
  plans_feature_standard_27: "5.000 Seitenaufrufe pro Monat",
  plans_feature_standard_27_tooltip:
    "5.000 einmalige Besuche pro Monat auf deiner Website oder deinem Kalender.",
  plans_feature_pro_27: "10.000 Seitenaufrufe pro Monat",
  plans_feature_pro_27_tooltip:
    "10 000 einmalige Besuche pro Monat auf deiner Website oder deinem Kalender.",
  plans_feature_enterprise_27: "Unbegrenzt",
  plans_feature_enterprise_27_tooltip:
    "Die Anzahl der einzelnen Besuche wird individuell festgelegt.",
  plans_feature_name_28: "Microsoft Outlook Integration",
  plans_feature_standard_28: "Ja",
  plans_feature_pro_28: "Ja",
  plans_feature_standard_28_tooltip:
    "Kontrolliere Termine in Echtzeit, exportiere alle Buchungen, Aufträge und Termine in den Outlook Kalender. Mach die ausgewählten Ereignisse für Deine Mitarbeiter und Kunden sichtbar. Erleichtere ihnen das Leben und steigere die Effizienz deines Unternehmens.",
  plans_feature_pro_28_tooltip:
    "Kontrolliere Termine in Echtzeit, exportiere alle Buchungen, Aufträge und Termine in den Outlook Kalender. Mach die ausgewählten Ereignisse für Deine Mitarbeiter und Kunden sichtbar. Erleichtere ihnen das Leben und steigere die Effizienz deines Unternehmens.",
  plans_feature_enterprise_28: "Ja",
  plans_feature_enterprise_28_tooltip:
    "Kontrolliere Termine in Echtzeit, exportiere alle Buchungen, Aufträge und Termine in den Outlook Kalender. Mach die ausgewählten Ereignisse für Deine Mitarbeiter und Kunden sichtbar. Erleichtere ihnen das Leben und steigere die Effizienz deines Unternehmens.",
  plans_feature_name_29: "Microsoft Teams Integration",
  plans_feature_standard_29: "Ja",
  plans_feature_standard_29_tooltip:
    "Erstelle einen Link zum Teams-Meeting gleich nach der Buchung.",
  plans_feature_pro_29: "Ja",
  plans_feature_pro_29_tooltip:
    "Erstelle einen Link zum Teams-Meeting gleich nach der Buchung.",
  plans_feature_enterprise_29: "Ja",
  plans_feature_enterprise_29_tooltip:
    "Erstelle einen Link zum Teams-Meeting gleich nach der Buchung.",
  plans_feature_name_31: "WhatsApp Integration",
  plans_feature_standard_31: "Ja",
  plans_feature_standard_31_tooltip:
    "Erstelle einen Link zum WhatsApp-Meeting gleich nach der Buchung.",
  plans_feature_pro_31: "Ja",
  plans_feature_pro_31_tooltip:
    "Erstelle einen Link zum WhatsApp-Meeting gleich nach der Buchung.",
  plans_feature_enterprise_31: "Ja",
  plans_feature_enterprise_31_tooltip:
    "Erstelle einen Link zum WhatsApp-Meeting gleich nach der Buchung.",
  plans_feature_name_32: "Erweiterte Erinnerungen",
  plans_feature_standard_32: "Nein",
  plans_feature_standard_32_tooltip:
    "Diese Option ist ab dem Pro-Tarif verfügbar.",
  plans_feature_pro_32: "Ja",
  plans_feature_pro_32_tooltip:
    "Erweiterte und präzise Erinnerungen, die festlegen, welche Erinnerungen, an wen und wann gesendet werden.",
  plans_feature_enterprise_32: "Ja",
  plans_feature_enterprise_32_tooltip:
    "Erweiterte und präzise Erinnerungen, die festlegen, welche Erinnerungen, an wen und wann gesendet werden.",
  plans_feature_name_33:
    "Erweiterte Verfügbarkeitspläne für Dienste und Standorte",
  plans_feature_33_tooltip:
    "Jeder Dienst und jeder Standort bekommt einen eigenen Plan, damit deine Kunden nur Termine sehen, die wirklich passen.",
  plans_feature_name_34: "Mobile App für Mitarbeiter",
  plans_feature_34_tooltip:
    "Dein Team sieht den Kalender und verwaltet Buchungen am Handy, auch unterwegs.",
  plans_feature_name_35: "Berichte und Analysen",
  plans_feature_35_tooltip:
    "Du siehst, wie viel du verdienst, was sich am besten verkauft und wann am meisten los ist. Jede Übersicht lädst du als CSV herunter.",
  plans_feature_name_36: "Buchungslimit pro Kunde",
  plans_feature_36_tooltip:
    "Du legst fest, wie oft eine Person einen Dienst buchen darf. Wer das Limit erreicht, kann online nicht mehr buchen.",
  plans_feature_name_37: "Doppelte Kunden zusammenführen",
  plans_feature_37_tooltip:
    "Dieselbe Person mit zwei E-Mail-Adressen wird zu einer Kundenkarte. Buchungen, Dateien und Tags landen an einem Ort.",
  plans_feature_name_38: "Cookie-Banner",
  plans_feature_38_tooltip:
    "Cookie-Einwilligungen auf deiner Website, ohne Plugin und ohne eigene Texte. Die Wahl der Besucher geht direkt an Google Ads und Analytics (Consent Mode v2).",
  plans_feature_name_39: "Automatisches Löschen von Gastdaten",
  plans_feature_39_tooltip:
    "Daten von Personen, die ohne Konto gebucht haben, verschwinden nach einer Frist, die du festlegst. Jede Löschung steht in einem Protokoll, das du als CSV herunterlädst.",
  plans_feature_name_40: "Schutz der Kundenkonten",
  plans_feature_40_tooltip:
    "Du verlangst sichere Passwörter und prüfst sie auf bekannte Datenlecks. Den Buchungsverlauf sieht nur, wer die eigene E-Mail-Adresse bestätigt hat.",
  plans_feature_name_41: "MCP-Server (ChatGPT, Claude und andere)",
  plans_feature_41_tooltip:
    "Du fragst ChatGPT oder Claude in normaler Sprache nach Terminen, Kunden und Umsatz, und die Antwort kommt direkt aus deinem Calendesk.",
  plans_feature_name_42: "Zugang zum Hilfezentrum",
  plans_feature_42_tooltip:
    "Schritt-für-Schritt-Anleitungen zu jeder Funktion, jederzeit abrufbar.",
  plans_feature_name_43: "Support per E-Mail",
  plans_feature_43_tooltip:
    "Schreib uns, und wir helfen dir bei einem Problem oder beim Einrichten einer Funktion.",
  plans_feature_name_44: "Support per Live-Chat",
  plans_feature_44_tooltip:
    "Du chattest mit unserem Team direkt aus dem Panel.",
  plans_feature_name_45: "Eigenes Branding im Admin-Panel",
  plans_feature_45_tooltip:
    "Das Panel, mit dem deine Mitarbeiter arbeiten, trägt das Logo und die Farben deiner Firma.",
  plans_feature_name_46: "Eigenes Customer-Success- und Support-Team",
  plans_feature_46_tooltip:
    "Ein Team, das dein Unternehmen kennt, begleitet dich beim Start und bei jeder Änderung.",
  plans_feature_section_1: "Grundfunktionen",
  plans_feature_section_2: "Benachrichtigungen",
  plans_feature_section_3: "Weitere Funktionen",
  plans_feature_section_4: "Datenschutz und DSGVO",
  plans_feature_section_5: "Integrationen",
  plans_feature_section_6: "Support und Betreuung",
  plans_trial_faq_2_title: "Kann ich mich jederzeit von Calendesk abmelden?",
  plans_trial_faq_2_description_1:
    "Wenn du dein Abonnement kündigen möchtest, werden wir das sehr bedauern, aber natürlich <b>kannst du das tun, wann immer du willst</b>. Calendesk bindet dich nicht an langfristige Verträge. Du kannst Calendesk mit monatlicher oder jährlicher Zahlung nutzen (bei jährlicher Zahlung erhältst du einen Rabatt von 20 %).",
  plans_trial_faq_3_title: "Kann ich meinen Plan jederzeit ändern?",
  plans_trial_faq_3_description_1:
    "Ja, natürlich.<b>Du kannst jederzeit zwischen den Tarifen wechseln.</b> Unser Zahlungsanbieter wird die Beträge neu berechnen, so dass du bei einem solchen Wechsel nichts verlierst. Wenn du den Plan während des Abrechnungszeitraums erhöhst, wird dir nur der verbleibende Zeitraum berechnet. Wenn du den Plan während des Abrechnungszeitraums herabsetzt, verwenden wir den verbleibenden Betrag für künftige Zahlungen oder erstatten ihn dir zurück.",
  plans_trial_faq_4_title:
    "Was geschieht nach Ablauf der Vertragslaufzeit? Verlängert sich der Antrag automatisch und wird eine zusätzliche Gebühr für den gesamten Zeitraum erhoben?",
  plans_trial_faq_4_description_1:
    'Ja, der gewählte Tarif verlängert sich automatisch. Wenn du nicht möchtest, dass sich der Plan im neuen Zeitraum verlängert, kannst du ihn jederzeit auf der Registerkarte "Konten und Zahlungen" kündigen.',
  plans_trial_faq_5_title:
    "Verliere ich mein Konto und meine Daten, wenn ich vergesse, meinen Calendesk-Nutzungszeitraum zu verlängern?",
  plans_trial_faq_5_description_1:
    "Deine Daten sind noch eine Zeit lang in unserem System verfügbar, so dass du sicher wieder auf dein Konto und das von dir erstellte Projekt zugreifen kannst.",
  plans_trial_faq_5_description_2:
    "Wenn die Vertragslaufzeit abgelaufen ist und dein Konto auch nur für ein paar Tage gesperrt wurde, hast du immer noch die Möglichkeit, es zurückzubekommen, sofern du die Gebühr bezahlst.",
  plans_trial_faq_5_description_3:
    "Sollte dies für dich schwierig oder unklar sein, wende dich bitte an unser Support-Team.",
  plans_trial_faq_6_title:
    "Wie erkenne ich, wann meine Nutzungsdauer zu Ende geht?",
  plans_trial_faq_6_description_1:
    "Sobald du dich bei deinem Calendesk-App-Konto angemeldet hast, werden in der rechten Ecke der Name deines Tarifplans und die verbleibende Zeit angezeigt.",
  plans_trial_faq_6_description_2:
    "Außerdem erhältst du kurz vor Ablauf deines Tarifs eine Benachrichtigung in Form eines Pop-up-Fensters. Außerdem wird dir eine E-Mail zugesandt.",
  plan_selected_title:
    "Herzlichen Glückwunsch! Du hast den Tarifplan @{plan} ausgewählt.",
  plan_selected_subtitle_1:
    "Schneide den Plan auf die Bedürfnisse deines Unternehmens zu, und wähle zusätzliche Pakete!",
  plan_selected_subtitle_2:
    "Du kannst die Pakete jederzeit über das App-Menü ein- und ausschalten.",
  "plugins_sms-notifications_cd_base_lite_name": "Kontakt-Paket",
  "plugins_sms-notifications_cd_base_lite_description":
    "Sende deinen Kunden einfach und schnell SMS-Benachrichtigungen. Bestätige Buchungen, erinnere an Termine und akzeptiere Terminänderungen. Das Paket enthält 150 SMS-Nachrichten mit der Möglichkeit, regelmäßig neue Nachrichten zu erwerben.",
  "plugins_sms-notifications_cd_base_standard_name": "Kontakt Pro-Paket",
  "plugins_sms-notifications_cd_base_standard_description":
    "Sende deinen Kunden SMS-Benachrichtigungen in noch größerer Zahl. Erinnere sie mit speziellen Nachrichten an Werbeaktionen, besondere Anlässe und Geburtstagsrabatte. Ermutige sie, sich zu melden und deine Website zu besuchen! Das Paket enthält 200 SMS-Nachrichten mit der Möglichkeit, regelmäßig neue Nachrichten zu kaufen.",
  "plugins_sms-notifications_cd_base_pro_name": "Kontakt Expert - Paket",
  "plugins_sms-notifications_cd_base_pro_description":
    "Sende deinen Kunden SMS-Benachrichtigungen in noch größerer Zahl. Erinnere sie mit speziellen Nachrichten an Werbeaktionen, besondere Anlässe und Geburtstagsrabatte. Ermutige sie, dich zu kontaktieren und deine Website zu besuchen! Das Paket enthält 250 SMS-Nachrichten mit der Möglichkeit, regelmäßig neue Nachrichten zu kaufen.",
  "plugins_mobile-app-staff_cd_base_lite_name": "Mobile App für Mitarbeiter",
  "plugins_mobile-app-staff_cd_base_lite_description":
    "Gib deinen Mitarbeitern die Möglichkeit, eine spezielle mobile App auf ihren Smartphones zu nutzen. Lass sie ihren Mitarbeiterkalender einsehen, die ihnen für den Tag zugewiesenen Aufgaben und die Kunden, die sie bedienen werden, überprüfen. Mit Push-Benachrichtigungen auf ihrem Telefon erhalten deine Mitarbeiter sofort alle Informationen, die sie von dir benötigen.",
  plugins_booking_cd_base_lite_name: "Buchungs-Paket",
  plugins_booking_cd_base_lite_description:
    "Füge deiner App die Möglichkeit hinzu, ein voll funktionsfähiges Buchungssystem für Kunden zu erstellen. Biete ihnen eine Auswahl an spezifischen Serviceoptionen (z. B. Waschen, Schneiden, Kämmen) und Zugang zu den Terminen deines Personals - lass deine Kunden wählen, bei wem sie einen Termin buchen möchten.",
  "plugins_google-calendar_cd_base_standard_name": "Google Kalender",
  "plugins_google-calendar_cd_base_standard_description":
    "Kontrolliere Termine in Echtzeit, exportiere alle Buchungen, Aufträge und Termine in den Google Kalender. Mach die ausgewählten Ereignisse für deine Mitarbeiter und Kunden sichtbar. Erleichtere ihnen das Leben und steigere die Effizienz deines Unternehmens. Erstelle Erinnerungen, Aufgabenlisten und einen Tagesplaner - füge Facebook-Events hinzu und erinnere dich an deine Kunden.",
  plugins_mobile_cd_base_lite_name: "Mobile - Paket",
  plugins_mobile_cd_base_lite_description:
    "Mach deine Website vollständig kompatibel mit mobilen Geräten (Smartphones und Tablets). Mit diesem Paket kannst du problemlos volle Kompatibilität erreichen.",
  plugins_management_cd_base_lite_name: "Management - Paket",
  plugins_management_cd_base_lite_description:
    "Schalte den unbegrenzten Zugang zur Marketing-Wissensdatenbank frei. Lerne effektive, einfache und leicht umsetzbare Tipps kennen, die dir helfen, Calendesk besser zu nutzen und dein Geschäft auszubauen. Hier findest du aktuelle Artikel, Kommentare und Studien und kannst dich regelmäßig über relevante Fakten informieren.",
  "plugins_alphanumeric-sms-sender_cd_base_standard_name":
    "Eigener SMS-Absendername",
  "plugins_alphanumeric-sms-sender_cd_base_standard_description":
    "Dein eigener SMS-Absendername in Nachrichten an Kunden. Ersetze eine langweilige und zufällige Telefonnummer durch deinen eigenen Namen und zeige dich von deiner besten Seite. Du kannst deinen eigenen Namen unter Profil -> dein Unternehmen festlegen.",
  "plugins_alphanumeric-sms-sender_cd_base_pro_name":
    "Eigener SMS-Absendername",
  "plugins_alphanumeric-sms-sender_cd_base_pro_description":
    "Dein eigener SMS-Absendername in Nachrichten an Kunden. Ersetze eine langweilige und zufällige Telefonnummer durch deinen eigenen Namen und zeige dich von deiner besten Seite. Du kannst deinen eigenen Namen unter Profil -> dein Unternehmen festlegen.",
  plans_thank_you_page_title:
    "Dein Tarif und die ausgewählten Zusatzpakete wurden aktiviert!",
  plans_thank_you_page_title_part_1:
    "Dein Plan und ausgewählte Zusatzpakete wurden",
  plans_thank_you_page_title_part_2: "aktiviert!",
  plans_thank_you_page_subtitle:
    'Du kannst sie jederzeit auf der Registerkarte "Deine Pakete" ein- oder ausschalten.',
  plans_thank_you_page_button: "Erste Schritte mit Calendesk",
  fill_invoice_data: "Die Rechnungsangaben vervollständigen.",
  cancel_plan_confirm_button_1: "Okay, ich will bleiben!",
  cancel_plan_confirm_button_2: "Plan stornieren :(",
  purchase_remove: "Löschen",
  wb_align_center: "Zentrieren",
  wb_container_fluid: "Volle Breite des Abschnitts",
  wb_image_to_right: "Bild nach rechts",
  wb_image_width: "Bildbreite in Pixel, z. B. 200",
  wb_image_height: "Bildhöhe in Pixel, z. B. 200",
  wb_button_width: "Breite der Schaltfläche in Pixel z. B. 200",
  wb_image_contain: "Das ganze Bild anpassen",
  wb_button_elevation: "Schatten (Stufe) z. B. 3",
  wb_height: "Höhe des Abschnitts",
  wb_image_hide_on_mobile: "Bild auf Smartphones ausblenden",
  wb_buttons_position_title: "Position der Schaltfläche",
  wb_form_position_title: "Formular Position",
  wb_image_position_title: "Position der Bilder",
  wb_position_top_right_title: "Oben rechts",
  wb_position_top_left_title: "Oben links",
  wb_position_top_center_title: "Oben Mitte",
  wb_position_bottom_right_title: "Unten rechts",
  wb_position_bottom_left_title: "Unten links",
  wb_position_bottom_center_title: "Unten Mitte",
  wb_create_new_website: "Neu starten",
  wb_image_hide: "Bild ausblenden",
  stripe_is_not_available_in_your_plan:
    "Stripe-Zahlungen sind im Lite-Tarif nicht verfügbar. Upgrade auf einen Standard- oder Pro-Tarif.",
  fakturownia_is_not_available_in_your_plan:
    "Rechnungsshop ist im Lite-Tarif nicht verfügbar. Upgrade auf einen Standard- oder Pro-Tarif.",
  help: "Hilfe",
  upselling: "Upselling",
  simple_store_product_list: "Produkte",
  simple_store_product_transaction_list: "Transaktionen",
  simple_store_product_list_product_name: "Name",
  simple_store_product_list_product_price: "Preis",
  no_simple_store_product_info:
    "Du hast noch keine Produkte hinzugefügt, klick unten, um dein erstes Produkt hinzuzufügen.",
  no_subscriptions_info:
    "Du hast noch keine Abonnements hinzugefügt. Klicke unten, um dein erstes Abonnement hinzuzufügen.",
  simple_store_product_add_title: "Produkt hinzufügen",
  subscriptions_add_title: "Abonnement hinzufügen",
  subscriptions_update_title: "Dein Abonnement aktualisieren",
  no_simple_store_product_transaction_info:
    "Du hast noch keinen Verkauf von Produkten registriert. Wenn Produkte bereits hinzugefügt wurden, kannst du unten den Verkauf eines beliebigen davon einem ausgewählten Kunden zuweisen.",
  simple_store_product_update_title: "Produkte bearbeiten",
  wb_button_edit_menu_simple_store_product: "Produkt auswählen",
  wb_button_edit_menu_booking: "Dienstleistung auswählen",
  wb_cta_button_type_1: "Weiterleitung",
  wb_cta_button_type_2: "Buchung",
  wb_cta_button_type_3: "Produkt",
  wb_cta_button_type_4: "Abonnement",
  simple_store_product: "Produkt",
  booking_payments: "Buchungen",
  payment_type_select_box: "Zahlungsmethode auswählen",
  wb_round_zero_title: "Kein",
  wb_round_sm_title: "Klein",
  wb_round_md_title: "Mittel",
  wb_round_lg_title: "Groß",
  wb_round_xl_title: "XL",
  wb_round_pill_title: "Pille",
  wb_round_circle_title: "Kreis",
  wb_image_rounded: "Abrundung des Bildes",
  wb_gallery_image_number: "Anzahl der Fotos in der Galerie (Desktop)",
  wb_gallery_mobile_image_number:
    "Anzahl der Fotos in der Galerie (Smartphone)",
  wb_gallery_width: "Breite der Galerie in Prozent, z. B. 50",
  wb_gallery_height: "Höhe der Galerie in Pixel, z. B. 200",
  wb_gallery_distance: "Abstand zwischen den Bildern",
  wb_image_zoom_on_click: "Das Bild anklicken, um es zu vergrößern",
  wb_gallery_style: "Stil der Galerie",
  wb_gallery_style_1_title: "Stil 1",
  wb_gallery_style_2_title: "Stil 2",
  wb_gallery_style_3_title: "Stil 3",
  help_center_title:
    "Erfahre in kurzen Videos mehr über die Calendesk-Funktionen.",
  help_center_group_1: "Einleitung",
  help_center_group_2: "Buchungssystem",
  help_center_group_3: "Kunden und Benachrichtigungen",
  help_center_group_4: "Website-Editor",
  help_center_group_5: "Mobile App",
  help_center_group_6: "Zahlungen",
  help_center_group_1_video_1_title:
    "Einführung in Calendesk - ein schneller Überblick über alle Funktionen",
  help_center_group_1_video_2_title: "Vervollständige deine Unternehmensdaten",
  help_center_group_2_video_1_title:
    "Mitarbeiter - wie füge ich eine neue Person hinzu, die Buchungen entgegennimmt?",
  help_center_group_2_video_2_title:
    "Dienstleistungen - was sind sie und wie füge ich eine neue Dienstleistung in das Buchungssystem ein?",
  help_center_group_2_video_3_title:
    "Dienstleistungen - wie verwaltet man die Liste der Dienstleistungen?",
  help_center_group_2_video_4_title:
    "Kalender - wie kann ich meinen Buchungskalender verwalten?",
  help_center_group_2_video_5_title:
    "Kalender - Termine, die nicht mit dem Besuch des Kunden zusammenhängen",
  help_center_group_2_video_6_title:
    "Kalender - Einschränkungen in den Kalendern der Kunden",
  help_center_group_3_video_1_title:
    "Wie kann ich meine Kunden in Calendesk verwalten? Versand von Benachrichtigungen an Kunden und Newsletter.",
  help_center_group_3_video_2_title:
    "Personalisierung von E-Mail-, SMS- und Push-Benachrichtigungen",
  help_center_group_4_video_1_title:
    "Deine eigene Website - eine Einführung in den Calendesk-Editor",
  help_center_group_4_video_2_title:
    "Eigene Website - Überblick über die grundlegenden Funktionalitäten",
  help_center_group_4_video_3_title: "Eigene Website - Kopf- und Fußzeile",
  help_center_group_4_video_4_title:
    "Eigene Website - Kopf- und Fußzeile ersetzen",
  help_center_group_4_video_5_title:
    "Eigene Website - wie fügt man Abschnitte hinzu?",
  help_center_group_4_video_6_title:
    "Eigene Website - wie richtet man eine Domain ein?",
  help_center_group_5_video_1_title:
    "Mobile App mit Buchungssystem - Beschreibung des Webeditors",
  help_center_group_5_video_2_title:
    "Mobile App mit Buchungssystem - Präsentation der App im App Store oder bei Google Play",
  help_center_group_6_video_1_title:
    "Wie kann ich Stripe-Zahlungen mit meinem Buchungssystem und meinem Shop verknüpfen?",
  help_center_group_6_video_2_title:
    "Wie aktiviert man den Przelewy24-Service in Stripe?",
  help_center_group_6_video_3_title:
    "Wie berechnest du deine Dienstleistungen online?",
  help_center_group_6_video_4_title:
    "Der simple Online-Shop in Calendesk - wie kann man Produkte online bezahlen?",
  help_center_group_1_video_1_description:
    "In diesem Video erfährst du, welche Möglichkeiten Calendesk bietet. Hier wird die Struktur der gesamten Plattform vorgestellt. In diesem Leitfaden erfährst du, wie du durch die einzelnen Module von Calendesk navigieren kannst.",
  help_center_group_1_video_2_description:
    "Deine Unternehmensdaten können auf deiner Website angezeigt werden. In diesem Abschnitt erfährst du, wo du deine Unternehmensdaten eingeben kannst, wo du die Öffnungszeiten deines Arbeitsplatzes festlegen kannst, wo du Links zu sozialen Medien hinzufügen kannst und wie du die Allgemeinen Geschäftsbedingungen und die Datenschutzrichtlinie erstellen kannst.",
  help_center_group_2_video_1_description:
    "In diesem Video erfährst du, wie du ein Buchungssystem einrichten kannst. Hier erfährst du mehr über das Hinzufügen von Mitarbeitern, das Erteilen von Berechtigungen und das Konfigurieren ihrer Konten in Calendesk.",
  help_center_group_2_video_2_description:
    "In diesem Teil der Anleitung erfährst du, wie du Dienstleistungen hinzufügen und konfigurieren kannst. Hier erfährst du, wie du Zeiträume hinzufügen, Preise zuweisen und die Dienstleistungen beschreiben kannst.",
  help_center_group_2_video_3_description:
    "Mit der Dienstleistungsliste kannst du deine Dienstleistungen einfach verwalten und neue Angebote hinzufügen.",
  help_center_group_2_video_4_description:
    "Hier erfährst du, wie du den Calendesk-Kalender verwenden kannst. In diesem Video erklären wir, wie man Buchungen über die Mitarbeiterauswahl filtert und wie man Buchungen verwaltet.",
  help_center_group_2_video_5_description:
    "Was soll man tun, wenn ein Mitarbeiter Urlaub hat? In diesem Video erfährst du, wie du die Checkbox: „Ereignis, das nicht mit dem Besuch des Kunden zusammenhängt“ verwendest.",
  help_center_group_2_video_6_description:
    "Mit Admin-Rechten hast du unbegrenzte Möglichkeiten, deinen Kalender zu verwalten. Erfahre mehr in diesem Video.",
  help_center_group_3_video_1_description:
    "In diesem Kapitel erfährst du, mit welchen Tools du gute Kundenbeziehungen pflegen kannst und wie du Kunden in der Calendesk-Plattform verwaltest.",
  help_center_group_3_video_2_description:
    "Erfahre, wie du Benachrichtigungen verwendest und wie du sie ändern kannst. Es ist ein ideales Mittel, um mit Kunden und Mitarbeitern zu kommunizieren!",
  help_center_group_4_video_1_description:
    "Erfahre, wie du mit unserem Website-Editor eine vollständig personalisierte Website erstellen kannst, über die deine Kunden Termine bei dir buchen können. ",
  help_center_group_4_video_2_description:
    "Sieh, wie die Personalisierung deiner Website funktioniert. Der Aufbau deines Online-Images kann definitiv mehr Spaß machen, als du glaubst!",
  help_center_group_4_video_3_description:
    "Erfahre mehr über die wichtigsten Abschnitte, aus denen du deine Website aufbauen wirst.",
  help_center_group_4_video_4_description:
    "Erfahre, wie du die Kopf- und Fußzeile im Webeditor ersetzen kannst",
  help_center_group_4_video_5_description:
    "Abschnitte im Webseiten-Editor. Lerne, wie man Abschnitte hinzufügt und wie man sie verwaltet.",
  help_center_group_4_video_6_description:
    "Dieses Video erklärt, wie du deine eigene Domäne hinzufügen kannst. Eine gute Domäne ist der Schlüssel zum Erfolg deines Unternehmens. Hier erfährst du, wie du deine Webadresse einrichtest.",
  help_center_group_5_video_1_description:
    "Eine mobile App mit einem Buchungssystem ist etwas, um das dich jeder beneiden wird. Erfahre, wie du deine eigene App erstellst und im App Store und bei Google Play veröffentlichen kannst.",
  help_center_group_5_video_2_description:
    "So sieht deine mobile App im Shop aus. In diesem Video erfährst du, wie man das macht.",
  help_center_group_6_video_1_description:
    "Ein Buchungssystem mit Zahlungen ist etwas, was das moderne Unternehmen braucht. Hier erfährst du, wie du dein Stripe-Konto mit deinem Calendesk-Konto verknüpfst.",
  help_center_group_6_video_2_description:
    "Stripe-Zahlungen bieten mehrere zusätzliche Konfigurationsmöglichkeiten. Sieh, wie du zusätzliche Zahlungen über den Betreiber Przelewy24 aktivieren kannst.",
  help_center_group_6_video_3_description:
    "Erfahre, wie du deine Dienste in Calendesk berechnen kannst. Hier erfährst du mehr über vorausbezahlte Besuche, Zahlungsstatus und siehst, wo du nach Zahlungstransaktionen suchen kannst.",
  help_center_group_6_video_4_description:
    "Ein einfacher Online-Shop bei Calendesk? Es ist möglich! Sieh, wie du deine Produkte, für die du Einmalzahlungen akzeptierst, mit deiner Website verbinden kannst.",
  related_articles: "Verwandte Artikel",
  article_1_title: "Calendesk-Plattform - Überblick",
  article_2_title: "Profil - Dein Unternehmen",
  article_3_title: "Mitarbeiter - Mitarbeiter hinzufügen",
  article_4_title: "Dienstleistungen - Kategorie hinzufügen",
  article_5_title: "Dienstleistungen - eine Dienstleistung hinzufügen",
  article_6_title: "Dienstleistungen - Liste der Dienstleistungen",
  article_7_title: "Mitarbeiter - Kalender",
  article_8_title: "Kunden - Kundenliste",
  article_9_title: "Kunden - Kunde hinzufügen",
  article_10_title: "Kunden - Buchungen",
  article_11_title: "Kunden - Newsletter",
  article_12_title: "Kunden - Benachrichtigungen",
  article_13_title: "Einstellungen - Benachrichtigungen",
  article_14_title: "Extras - Website",
  article_15_title: "Website-Personalisierung",
  article_16_title: "Website - Domäne",
};
